//==========================Pre-loader=======================//
$(document).ready(function(){
	window.ajax_cart = true;
  	jQuery(window).load(function() { jQuery(".ttloader").fadeOut("slow"); });
});

//==========================back-to-top=======================//
$(window).scroll(function() {
if ($(this).scrollTop() > 500) {
$('.top_button').fadeIn(500);
} else {
$('.top_button').fadeOut(500);
}
});	
$('.top_button').click(function(event) {
event.preventDefault();	
$('html, body').animate({scrollTop: 0}, 800);
});

//==================== account toggle ====================//
$(document).ready(function(){
	$(".user-background").click(function(){
	$(".theme_header-dropdown .my-account").slideToggle(500);
	$('.theme_header-dropdown').toggleClass('active'); 
	});
});


//==================== cart toggle ====================//
$(document).ready(function(){
	$(".site-header__cart").click(function(){
	$(".site-header__cart .cart-content.block").slideToggle(500);
	$('.site-header__cart').toggleClass('active'); 
	});
});


//====================== collection tab =======================//
$(document).ready(function() {
    $('.product_tab-block ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
  });


//=============================== Reviews Slider ==================================//

$('.quotes-slider.owl-carousel').owlCarousel({
    loop:false,
    margin: 0,
    nav:true,
  	dots: false,
    autoplay: false,
    transitionStyle : "backSlide",
    responsive:{
        0:{
            items:1
        },
        600:{
            items:1
        },
        1000:{
            items:1
        }
    }
})

//================================= testimonial append ==================================//

$(document).ready(function() {
    more_center()
     $( ".footer-middle .footer-right" ).append( $( ".testimonial" ) );
});

//========================blog list slider==========================// 

$('#blog_slider.owl-carousel').owlCarousel({
    loop:false,
    nav:true,
  	dots: false,
    autoplay: false,
    responsive:{
        0:{
            items:1
        },
        480:{
            items:1
        },
        750:{
            items:2
        },
        1270:{
            items:3
        }
    }
})


//====================== collection product slider======================//

$('.special_products .slider.owl-carousel').on('changed.owl.carousel initialized.owl.carousel', function(event) {
    $(event.target)
      .find('.owl-item').removeClass('last')
      .eq(event.item.index + event.page.size - 1).addClass('last');
  }).owlCarousel({
    loop:true,
  	//margin:10,
    nav:true,
  	dots: false,
  	rows:2,
    responsive:{
        0:{
            items:1
        },
        480:{
            items:1
        },
      	750:{
            items:1
        },
        1271:{
            items:1
        }
    }
})

//====================special title insert script====================//

$(document).ready(function() {
     $(".special_products .section-header").insertBefore('.special_products .product-desc .product-desc-text');
});
 



//====================== collection product slider ======================//

$('.tab-slider.owl-carousel').on('changed.owl.carousel initialized.owl.carousel', function(event) {
    $(event.target)
      .find('.owl-item').removeClass('last')
      .eq(event.item.index + event.page.size - 1).addClass('last');
  }).owlCarousel({
    loop: true,
    nav: true,
  	dots: false,
  	rows:1,
    responsive:{
        0:{
            items:1
        },
        480:{
            items:2
        },
      	750:{
            items:3
        },
        1271:{
            items:4
        }
    }
})



//====================== collection product slider======================//

$('.slider.owl-carousel').on('changed.owl.carousel initialized.owl.carousel', function(event) {
    $(event.target)
      .find('.owl-item').removeClass('last')
      .eq(event.item.index + event.page.size - 1).addClass('last');
  }).owlCarousel({
    loop:true,
  	//margin:10,
    nav:true,
  	dots: false,
  	rows:2,
    responsive:{
        0:{
            items:1
        },
        480:{
            items:2
        },
      	750:{
            items:3
        },
        1271:{
            items:4
        }
    }
})



/*=====================  More site navigation =======================*/
function more_left() {
  if ($(window).width() > 1750){
    var max_elem = 7;
    var items = $('.header-middle #SiteNav > li');
    var surplus = items.slice(max_elem, items.length);
    surplus.wrapAll('<li class="more-site-nav logo--left hiden_menu"><div class="site-nav__dropdown"><ul>');
    $('.logo--left .hiden_menu').prepend('<a class="logo--left__link site-nav__link site-nav__link--main" href="#">more</a>')
  }
  else if ($(window).width() > 1440){
    var max_elem = 5;
    var items = $('.header-middle #SiteNav > li');
    var surplus = items.slice(max_elem, items.length);
    surplus.wrapAll('<li class="more-site-nav logo--left hiden_menu"><div class="site-nav__dropdown"><ul>');
    $('.logo--left .hiden_menu').prepend('<a class="logo--left__link site-nav__link site-nav__link--main" href="#">more</a>')
  }
  else {
    var max_elem = 3;
    var items = $('.header-middle #SiteNav > li');
    var surplus = items.slice(max_elem, items.length);
    surplus.wrapAll('<li class="more-site-nav logo--left hiden_menu"><div class="site-nav__dropdown"><ul>');
    $('.logo--left .hiden_menu').prepend('<a class="logo--left__link site-nav__link site-nav__link--main" href="#">more</a>')
  }
}
$(document).ready(function() {
    more_left()
});

function more_center() {
  if ($(window).width() > 1600){
    var max_elem = 4;
    var items = $('.logo-align--center .header-left #SiteNav > li');
    var surplus = items.slice(max_elem, items.length);
    surplus.wrapAll('<li class="more-site-nav logo--center hiden_menu"><div class="site-nav__dropdown"><ul>');
    $('.logo--center .hiden_menu').prepend('<a class="logo--center__link site-nav__link site-nav__link--main" href="#">more</a>')
  }
  else if ($(window).width() > 1269){
    var max_elem = 4;
    var items = $('.logo-align--center .header-left #SiteNav > li');
    var surplus = items.slice(max_elem, items.length);
    surplus.wrapAll('<li class="more-site-nav logo--center hiden_menu"><div class="site-nav__dropdown"><ul>');
    $('.logo--center .hiden_menu').prepend('<a class="logo--center__link site-nav__link site-nav__link--main" href="#">more</a>')
  }
  else {
    var max_elem = 3;
    var items = $('.logo-align--center .header-left #SiteNav > li');
    var surplus = items.slice(max_elem, items.length);
    surplus.wrapAll('<li class="more-site-nav logo--center hiden_menu"><div class="site-nav__dropdown"><ul>');
    $('.logo--center .hiden_menu').prepend('<a class="logo--center__link site-nav__link site-nav__link--main" href="#">more</a>')
  }
}


//================================= Related Product carousel ==================================//
$('.related.slider.owl-carousel').on('changed.owl.carousel initialized.owl.carousel', function(event) {
    $(event.target)
      .find('.owl-item').removeClass('last')
      .eq(event.item.index + event.page.size - 1).addClass('last');
  }).owlCarousel({
    loop:true,
  	margin:10,
    nav:true,
  	dots: false,
    responsive:{
        0:{
            items:2
        },
        551:{
            items:3
        },
      	991:{
            items:4
        },
        1271:{
            items:5
        }
    }
})

$('.related.slider.owl-carousel').find('.owl-nav').removeClass('disabled');

//========================brand list slider==========================//
$('#brand-slider.owl-carousel').owlCarousel({
    loop:true,
    margin:10,
    nav: true,
  	dots: false,
    autoplay: true,
    responsive:{
        0:{
            items:1
        },
        480:{
            items:2
        },
        750:{
            items:5
        },
        1270:{
            items:6
        }
    }
})


//========================productthumbnail slider==========================//
$('#thumbnail-carousel.owl-carousel').owlCarousel({
    loop:true,
    margin:15,
    nav:true,
  	dots: false,
    autoplay: true,
    responsive:{
        0:{
            items:2
        },
        480: {
            items:3
        },
        990:{
            items:4
        },
        1000:{
            items:4
        }
    }
})

//======================== Sticky header ======================//
function StickyHeader(){	
	"use strict";	
	var num = 115; //number of pixels before modifying styles
	
		jQuery(window).bind('scroll', function () {
			if (jQuery(window).scrollTop() > num) {
				jQuery('.header-fix').addClass('sticky-menu');
				jQuery('.site-header-fix').addClass('header-style');
				jQuery('.category-box').addClass('home-category-fix');
				jQuery('.home-category').addClass('home-category-fix1');
				
			} else {
				jQuery('.header-fix').removeClass('sticky-menu');		
				jQuery('.site-header-fix').removeClass('header-style');
				jQuery('.category-box').removeClass('home-category-fix');
			}
		})
}
jQuery(document).ready(function() { "use strict";   StickyHeader()});
jQuery(window).resize(function() {  "use strict";   StickyHeader()});

//====================== collection tab =======================//
$(document).ready(function() {
    $('.product-single__description ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
  
  });


/*==================sidebar toggle====================*/
function mobileToggleColumn1(){
  if ($(window).width() < 990){
    $(".side-bar h3.box-heading").append( "<span class='mobile_togglemenu'> </span>" );  
    $(".side-bar h3.box-heading").addClass('toggle');
    $(".side-box h3.box-heading").click(function(){
       $(this).toggleClass('active').parent().find('.box-content').slideToggle('slow');
    });    
  }
  else{
    $(".side-bar h3.box-heading").removeClass('toggle');
    $(".side-bar h3.box-heading").removeClass('active');
    $(".side-box .mobile_togglemenu").remove();
  }
}
$(document).ready(mobileToggleColumn1);


/*==================footer toggle====================*/
function mobileToggleColumn(){
  if ($(window).width() < 990){
    $(".site-footer .footer-box  h5,.testimonial h5").append( "<span class='mobile_togglemenu'> </span>" );  
    $(".site-footer .footer-box h5,.testimonial h5").addClass('toggle');
    $(".footer-box .link_title,.testimonial h5").click(function(){
       $(this).toggleClass('active').parent().find('.footer-content,.quotes-wrapper').slideToggle('slow');
    });    
  }
  else{
    $(".site-footer .footer-box  h5,.testimonial h5").removeClass('toggle');
    $(".site-footer .footer-box h5,.testimonial h5").removeClass('active');
    $(".footer-box .mobile_togglemenu,.testimonial .mobile_togglemenu").remove();
  }
}
$(document).ready(mobileToggleColumn);


//======================mobile menu toogle======================//
$(document).ready(function(){

 
  $("#MobileNav .mobile-nav__dropdown").parent().append("<span class='mobile_togglecolumn'></span>");
        $('#MobileNav .mobile_togglecolumn').click(function () {
            $(this).parent().toggleClass('active');
        });
  
   $("#MobileNav .mobile-nav__grand_dropdown").parent().append("<span class='mobile_togglecolumn'></span>");
        $('#MobileNav .mobile-nav__grand__item .mobile_togglecolumn').click(function () {
            $(this).parent().toggleClass('active');
        });
 		
});

/*================== sidebar category-box ===================*/
function mobileToggleMenu10(){
    $(".side-bar #CategoryBox  ul#SiteCat > li.site-cat--has-dropdown").append( "<span class='mobile_togglemenu'> </span>" );  
    $(".side-bar #CategoryBox  ul#SiteCat > li.site-cat--has-dropdown").addClass('toggle');
    $(".side-bar #CategoryBox  ul#SiteCat > li.site-cat--has-dropdown .mobile_togglemenu").click(function(){
       $(this).parent().toggleClass('active').find('.site-nav__dropdown').slideToggle('slow');    
    });    
}
$(document).ready(mobileToggleMenu10);

function mobileToggleMenu11(){
    $(".side-bar #CategoryBox  ul#SiteCat  li.site-cat--has-dropdown .site-nav__childlist-item-dropdown").append( "<span class='mobile_togglemenu'> </span>" );  
    $(".side-bar #CategoryBox  ul#SiteCat li.site-cat--has-dropdown .site-nav__childlist-item-dropdown").addClass('toggle'); 
    $(".side-bar #CategoryBox  ul#SiteCat li.site-cat--has-dropdown .site-nav__childlist-item-dropdown .mobile_togglemenu").click(function(){
       $(this).parent().toggleClass('active').find('.grand-child-has-dropdown').slideToggle('slow'); 
    });    
}
$(document).ready(mobileToggleMenu11);


//------------------------------ Responsive left column------------------
function responsivecolumn()
{
	if ($(document).width() <= 990)
	{
		$('.main-content .page-width.contents .side-bar').insertAfter('.main-content .page-width.contents .main-container');
	}
 	 if ($(document).width() <= 989)
	{
		$('.header-middle .site-header__search').appendTo('.header-bottom');
        $('.header-bottom .site-header__icons-wrapper').appendTo('.header-middle');
        $(".header-bottom").removeClass("header-fix");
      	$(".header-middle").addClass("header-fix");
	}
}
$(document).ready(function(){responsivecolumn(); });
$(window).resize(function(){responsivecolumn(); });


//------------------------------ thumbnail-carousel ------------------
/*$(document).ready(function() {
    $('.quotes-slider').bxSlider({
        mode: 'vertical',
        minSlides: 1,
        moveSlides: 2,
        slideMargin: 0,
        speed: 500,
        controls: false,
        pager: false,
      	auto: true,
        touchEnabled: true,
        infiniteLoop: true,
    });
});*/

//============================ search toggle ==============================//
$(document).ready(function(){
	$(".header-search-btn").click(function(){
	$(".search-header").slideToggle(500); 
    $('.header-search-btn').toggleClass('active'); 
	});
});

$(document).ready(function(){
  $('.instagram').insertAfter('.cat_cms.bottom-cms');
  $('.footer-top').insertAfter('.instagram');
});


//------------------------------ thumbnail-carousel ------------------
/*$(document).ready(function() {
    $('#thumbnail-carousel').bxSlider({
        mode: 'vertical',
        minSlides: 3,
        moveSlides: 1,
        slideMargin: 22,
        hideControlOnEnd: true,
        pager: false,
      	auto: true,
        touchEnabled: true,
        infiniteLoop: true,
    });
});*/



//=====================================Insert after-before =============================//
if ($(window).width() > 749) {
	$('.main-content .page-width .custom-content .custom__item-inner--text').insertBefore('.main-content .sub-container .product-container-collection .collection.collection-1');
}

//====================Parallax====================//
/*$(document).ready(function(){

    var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
    if (!isMobile) {
        if ($(".parallax").length) {
            $(".parallax").sitManParallex({
                invert: false
            });
        };
    } else {
        $(".parallax").sitManParallex({
            invert: true
        });
    }
  
});*/

 /*****************start animation script*******************/

jQuery(document).ready(function(){  						   
if (jQuery('body').is('.template-index'))	{
jQuery(window).scroll(function () { hb_animated_contents(); });
jQuery(window).load(function () { hb_animated_contents(); });
function hb_animated_contents() {
	  jQuery(".hb-animate-element:in-viewport").each(function (i) {
	  var $this = jQuery(this);
	  if (!$this.hasClass('hb-in-viewport')) {
	  setTimeout(function () {
	  $this.addClass('hb-in-viewport');
	  }, 150 * i);
	  }
	});
}	
}
else{}
						
});

/*****************end animation script*******************/



//====================newsletter first word script====================//


$(".newsletter-section .section-header .h2,.special_products .section-header h2").html(function(){
	  var text= $(this).text().trim().split(" ");
	  var first = text.shift();
	  return (text.length > 0 ? "<span>"+ first + "</span> " : first) + text.join(" ");
});



